import { useTheme } from 'next-themes'

import { THEME_CLASS } from '@/constants/theme'

/**
 * The palette on screen: the class the page's theme puts on <html>. Not
 * `resolvedTheme`, which names the user's pick (System in a light OS reads
 * `light`, shown as professional) and ignores a page's pin.
 */
export const useAppliedTheme = (): string | undefined => {
  const { forcedTheme, resolvedTheme } = useTheme()
  const theme = forcedTheme ?? resolvedTheme
  return theme === undefined
    ? undefined
    : (THEME_CLASS[theme as keyof typeof THEME_CLASS] ?? theme)
}
